import React, { useEffect, useState } from "react";
import WeatherCard from "./WeatherCard.js";
import {
  WeatherType,
  WeatherForecast,
  City,
  WeatherDescriptions,
} from "../types/weatherTypes.js";

interface CityWeatherProps {
  city: City;
  className?: string;
}

const CityWeather: React.FC<CityWeatherProps> = ({ city, className }) => {
  const [forecast, setForecast] = useState<WeatherForecast[]>([]);
  const [currentWeather, setCurrentWeather] = useState<WeatherForecast | null>(
    null,
  );

  const generateTerribleForecast = (days = 5): WeatherForecast[] => {
    const terribleWeatherTypes = Object.values(WeatherType);
    return Array.from({ length: days }, (_, i) => {
      const date = new Date();
      date.setDate(date.getDate() + i);
      const weatherType =
        terribleWeatherTypes[
          Math.floor(Math.random() * terribleWeatherTypes.length)
        ];

      let temp: number;
      if (weatherType === WeatherType.HEATWAVE) {
        temp = Math.floor(Math.random() * 15) + 35; // 35-50°C
      } else if (
        [WeatherType.SNOW, WeatherType.FREEZING_RAIN].includes(weatherType)
      ) {
        temp = Math.floor(Math.random() * 15) - 30; // -30 to -5°C
      } else {
        temp = Math.floor(Math.random() * 10) + 1; // 1-10°C
      }

      // TODO: Make minimum and maximum constants
      const precipitation =
        weatherType === WeatherType.HEATWAVE
          ? 0
          : Math.floor(Math.random() * 50) + 30;

      return {
        date: date.toLocaleDateString("en-CA", {
          weekday: "short",
          month: "short",
          day: "numeric",
        }),
        weatherType,
        temp,
        precipitation,
        description: WeatherDescriptions[weatherType],
        feelsLike: temp - (weatherType === WeatherType.WIND ? 10 : 0),
        humidity: Math.floor(Math.random() * 50) + 50,
        windSpeed: Math.floor(Math.random() * 50) + 20,
      };
    });
  };

  useEffect(() => {
    setForecast(generateTerribleForecast());
  }, [city]);

  useEffect(() => {
    setCurrentWeather(forecast[0]);
  }, [forecast]);

  const refreshForecast = () => {
    setForecast(generateTerribleForecast());
  };

  return (
    <div className={className}>
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-2xl font-bold">
          {city.name} Weather <span className="blinking">⚠️</span>
        </h2>
        <button
          onClick={refreshForecast}
          className="rounded-lg bg-red-500 px-4 py-2 transition-colors hover:bg-red-600"
        >
          <i className="fas fa-sync-alt mr-2"></i>Refresh Misery
        </button>
      </div>

      {currentWeather && <WeatherCard forecast={currentWeather} />}

      <h3 className="mt-8 mb-4 text-xl font-semibold">
        5-Day Forecast of Impending Doom
      </h3>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        {forecast.map((day, index) => (
          <WeatherCard key={index} forecast={day} />
        ))}
      </div>
    </div>
  );
};

export default CityWeather;
